import { Button as MuiButton } from "@mui/material";
import { ComponentProps } from "react";

export const Button = ({ ...props }: ComponentProps<typeof MuiButton>) => {
	return <MuiButton variant="contained" color="primary" {...props} />;
};
